export const needToLoginErrors = [
    "CREDENTIAL_BLOCKED",
    "CREDENTIAL_NOT_EXIST",
    "ACCESS_TOKEN_INACTIVATED",
    "ACCESS_TOKEN_NOT_PROVIDED",
    "ACCESS_TOKEN_NOT_EXIST",
    "ACCESS_TOKEN_REFRESHED",
    "ACCESS_TOKEN_MODIFIED",
    "ACCESS_TOKEN_MALFORMED",
    "REFRESH_TOKEN_EXPIRED",
    "REFRESH_TOKEN_REFRESHED",
    "REFRESH_TOKEN_INACTIVATED",
    "REFRESH_TOKEN_NOT_EXIST",
    "REFRESH_TOKEN_MODIFIED",
    "REFRESH_TOKEN_MALFORMED",
    "REFRESH_TOKEN_NOT_PROVIDED",
    // legacy
    "UNAUTHORIZED",
    "ACCOUNT_IS_BLOCKED",
    "NOT_EXIST",
    "INVALID_TOKEN_FORMAT",
    "ACCESS_TOKEN_NOT_EXIST",
    "UNSUCCESFUL_REFRESH",
];
export const tokenExpiredErrors = [
    "ACCESS_TOKEN_EXPIRED",
    // legacy
    "TOKEN_EXPIRED",
    "EXPIRED_TOKEN",
];
export const permissionInsufficientErrors = [
    "CREDENTIAL_PERMISSION_INSUFFICIENT",
    // legacy
    "ACCESS_DENIED",
];
export const ErrorReasonKey = "details";
//# sourceMappingURL=authErrorDetails.js.map